import gql from "graphql-tag";
import { useMutation } from "@apollo/react-hooks";
import { GetChannelQuery } from "../queries/GetChannel";
import { GetChannelsQuery } from "../queries/GetChannels";
import { GetDecksQuery } from "../queries/GetDecks";

export const UNARCHIVE_CHANNEL = gql`
  mutation ($id: ID!) {
    unarchiveChannel(input: { id: $id }) {
      channel {
        id
        isDirect
        isArchived
      }
      success
    }
  }
`;

export const useUnarchiveChannel = (id) => {
  const [mutation, response] = useMutation(UNARCHIVE_CHANNEL);
  const successful = response?.data?.unarchiveChannel?.success ?? false;

  const execute = () => {
    const variables = { id: id };
    return mutation({
      variables,
      refetchQueries: [
        { query: GetChannelQuery, variables: { id: id } },
        { query: GetChannelsQuery },
        {
          query: GetChannelsQuery,
          variables: { filter: { isArchived: false } },
        },
        {
          query: GetChannelsQuery,
          variables: { filter: { type: "DIRECT", isArchived: false } },
        },
        {
          query: GetChannelsQuery,
          variables: { filter: { type: "TEAM", isArchived: false } },
        },
        { query: GetDecksQuery },
      ],
    });
  };

  return { execute, response, successful };
};
